/** Fixed-height (h-64) centered error message with a Retry button.
 *
 * Extracted verbatim from the access-management pages (MenuManagementPage /
 * UserRoleAssignmentPage / WebAccessPage), where this exact markup was
 * duplicated inside each page's `if (error)` early return. The retry handler
 * was the only per-page variation. */
export function RetryErrorState({
  error,
  onRetry,
}: {
  error: string;
  onRetry: () => void;
}) {
  return (
    <div className="flex flex-col items-center justify-center h-64 text-red-600">
      <p>{error}</p>
      <button
        onClick={onRetry}
        className="mt-4 px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700"
      >
        Retry
      </button>
    </div>
  );
}
